import { CheckCircle, Copy } from 'lucide-react'
import type { NodeExecution } from 'sprites-types/api/v2/workflows'
import { getToolResultSchema } from 'sprites-types/workflow/tools/common'
import { wordpressPublishPage } from 'sprites-types/workflow/tools/wordpressPublishPage'
import { ContextMenuWrapper } from '../shared/ContextMenuWrapper'
import {
  createWorkflowToolComponent,
  type WorkflowToolComponentProps,
} from '../shared/WorkflowToolComponent'
import { SchemaValidationError } from '../shared/safeParseToolResult'

function WordPressPublishPageDisplayComponent({ nodeExecution }: WorkflowToolComponentProps) {
  const schema = getToolResultSchema(wordpressPublishPage, nodeExecution.inputs)
  const parseResult = schema.safeParse(nodeExecution.outputs)

  if (!parseResult.success) {
    return <SchemaValidationError error={parseResult.error} nodeExecution={nodeExecution} />
  }

  const { url, title } = parseResult.data

  const handleCopyUrl = async () => {
    await navigator.clipboard.writeText(url)
  }

  return (
    <ContextMenuWrapper
      actions={[
        {
          id: 'copy-url',
          label: 'Copy URL',
          icon: <Copy className="h-3.5 w-3.5" />,
          onClick: handleCopyUrl,
        },
      ]}
    >
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="block rounded-3xl border border-gray-200/50 bg-white/70 text-black shadow-xl backdrop-blur-[8px] transition-all hover:shadow-2xl"
      >
        <div className="flex items-start gap-4 px-4 py-3">
          <div className="mt-1 flex-shrink-0">
            <div className="rounded-full bg-blue-100 p-2">
              <CheckCircle className="h-5 w-5 text-blue-600" />
            </div>
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-sm font-semibold text-gray-900">WordPress page published</div>
            <div className="mt-1 text-sm text-gray-600">{title}</div>
          </div>
        </div>
      </a>
    </ContextMenuWrapper>
  )
}

function downloadWordPressPublishPage(_nodeExecution: NodeExecution): Promise<void> {
  return Promise.resolve()
}

function wordpressPublishPageToMarkdown(_nodeExecution: NodeExecution): string {
  return ''
}

export const WordPressPublishPageDisplay = createWorkflowToolComponent(
  WordPressPublishPageDisplayComponent,
  downloadWordPressPublishPage,
  wordpressPublishPageToMarkdown
)
